import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { errMsg } from "@/lib/api";
import { portalApi } from "@/lib/portalApi";
import { usePortalAuth } from "@/context/PortalAuthContext";

export default function PortalProfile() {
  const { account, refresh } = usePortalAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const [sent, setSent] = useState(null);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const r = (await portalApi.post("/auth/change-email", { ...f, base: window.location.origin })).data;
      setSent(r); setF({ email: "", password: "" }); await refresh();
      toast.success(`Verification link sent to ${r.pending_email}`);
    } catch (err) { setError(errMsg(err)); }
  };
  const pending = sent?.pending_email || account?.pending_email;
  return (
    <div className="max-w-xl space-y-6" data-testid="portal-profile">
      <div><h1 className="text-2xl font-semibold text-slate-900">Profile</h1><p className="text-sm text-slate-500">{account?.customer_name}</p></div>
      <section className="rounded-lg border border-slate-200 bg-white p-5">
        <div className="text-xs uppercase tracking-wide text-slate-500">Login email</div>
        <div className="mt-1 font-medium text-slate-900" data-testid="portal-profile-email">{account?.email}</div>
        {pending && <p className="mt-2 rounded-md bg-sky-50 px-3 py-2 text-sm text-sky-800" data-testid="portal-profile-pending">Pending verification: {pending}. Click the link we emailed to that address within 24 hours. Until then, keep signing in with {account?.email}.</p>}
        {sent?.verify_url && <p className="mt-2 break-all text-xs text-slate-500" data-testid="portal-profile-verify-url">Demo address, no email sent. Verification link: <a className="underline" href={sent.verify_url}>{sent.verify_url}</a></p>}
      </section>
      <form onSubmit={submit} className="space-y-3 rounded-lg border border-slate-200 bg-white p-5" data-testid="portal-change-email-form">
        <h2 className="text-base font-semibold text-slate-900">Change login email</h2>
        <Input type="email" required data-testid="portal-change-email-input" placeholder="New email address" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <PasswordInput required data-testid="portal-change-email-password" placeholder="Current password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
        {error && <p className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700" data-testid="portal-change-email-error">{error}</p>}
        <Button type="submit" data-testid="portal-change-email-submit" className="bg-[#13294B] hover:bg-[#1c3a66]">Send verification link</Button>
      </form>
    </div>
  );
}
